import { observer } from 'mobx-react'

import type { RecommendationAction } from 'modules/timeoff/components/LeaveApprovalRecommendation/RecommendationAction'
import type LeaveForm from 'modules/timeoff/lib/LeaveForm'
import type Leave from 'modules/timeoff/store/models/Leave'

import AcceptButton from './AcceptButton'
import RejectButton from './RejectButton'

interface ActionButtonsProps {
  leave: Leave
  form: LeaveForm
  onFetchStats: () => void
  onReject: () => void
  onChange?: () => void
  canApprove: boolean
  canUpdate: boolean
  canRemove: boolean
  isManagerOrAdmin: boolean
  isSubmitDisabled: boolean
  isLoading: boolean
  isCurrentApprover: boolean
  materializedApprovalFlowId?: string
  approvalFlowId?: string
  fromShifts?: boolean
  onClose: () => void
  onlySubmit?: boolean | undefined
  employeeId: string
  recommendationAction?: RecommendationAction
  canApproveFromFlow?: boolean
  hasPendingChanges?: boolean
}

const ActionButtons = ({
  leave,
  form,
  onFetchStats,
  onReject,
  onChange,
  canApprove,
  canUpdate,
  canRemove,
  isManagerOrAdmin,
  isSubmitDisabled,
  isLoading,
  isCurrentApprover,
  materializedApprovalFlowId,
  approvalFlowId,
  fromShifts = false,
  onClose,
  onlySubmit = false,
  employeeId,
  recommendationAction = undefined,
  canApproveFromFlow,
  hasPendingChanges
}: ActionButtonsProps) => {
  if (leave.isRejected() && !isManagerOrAdmin) return null

  return (
    <>
      <RejectButton
        form={form}
        leave={leave}
        onFetchStats={onFetchStats}
        onReject={onReject}
        onChange={(...args) => {
          if (onChange) {
            onChange(...args)
          }
        }}
        canApprove={canApprove}
        canUpdate={canUpdate}
        canRemove={canRemove}
        isCurrentApprover={isCurrentApprover}
        approvalFlowId={approvalFlowId}
        isManagerOrAdmin={isManagerOrAdmin}
        isLoading={isLoading}
        fromShifts={fromShifts}
        employeeId={employeeId}
        recommendationAction={recommendationAction}
        canApproveFromFlow={canApproveFromFlow}
      />
      <AcceptButton
        form={form}
        leave={leave}
        onFetchStats={onFetchStats}
        canApprove={canApprove}
        canUpdate={canUpdate}
        isCurrentApprover={isCurrentApprover}
        materializedApprovalFlowId={materializedApprovalFlowId}
        approvalFlowId={approvalFlowId}
        disabled={isSubmitDisabled}
        fromShifts={fromShifts}
        onClose={onClose}
        onlySubmit={onlySubmit ? true : undefined}
        employeeId={employeeId}
        recommendationAction={recommendationAction}
        canApproveFromFlow={canApproveFromFlow}
        hasPendingChanges={hasPendingChanges}
      />
    </>
  )
}

export default observer(ActionButtons)
